package de.oevbs.kunde.kundenportal2.components

import de.oevbs.kosmos.ui.forms.imagetoggle.ImageToggle
import de.oevbs.kosmos.ui.forms.imagetoggle.imageToggleFormControl
import dev.fritz2.core.RenderContext
import dev.fritz2.core.Tag
import org.w3c.dom.HTMLDivElement

/**
 * Wrapper-Komponente/Workaround, die eine ImageToggle-Komponente ohne Label auf der linken Seite erzeugt.
 *
 * Hierzu wird intern ein [imageToggleFormControl] verwendet.
 * Mittels [initialize]-Block kann die Komponente analog zu diesem initialisiert werden.
 *
 * FIXME: Dies ist ausdrücklich ein Workaround! Die Komponente sollte nativ und ohne CSS-Hack im Kosmos
 *  bereitgestellt werden!
 */
fun <T> RenderContext.imageToggleKupo(initialize: ImageToggle<T>.() -> Unit): Tag<HTMLDivElement> =
    /**
     * Damit die ImageToggle-Komponente sich gut in das Layout einfügt (ausgerichtet ganz links), muss hier
     * leider ein wenig auf CSS-Ebene getrickst werden. Dazu sind folgende beiden Maßnahmen erforderlich:
     * - Eine CSS-Variable `--form-label-width` auf einen negativen Wert setzen (eigentlich ist diese
     *   vorgesehen, um das Label größer zu machen!). Dies ist tatsächlich in Kosmos so vorgesehen, um
     *   in Antragsstrecken an bestimmten Stellen die Labels eines ganzen Blocks besser an den Platz anpassen
     *   zu können.
     * - Zusätzlich muss der `column-gap`-Wert des FormControl-Grids überschrieben und auf `0` gesetzt werden.
     */
    div("flex flex-row items-left [--form-label-width:-1rem]") {
        imageToggleFormControl<T> {
            initialize()
        }.apply { inlineStyle("column-gap:0px;") }
    }